import { useState } from "react";
import { useUpdate } from "./useUpdate";

export const usePropAsState = <T>(propValue: T, initial?: T): [T, (v: T) => void] => {
  const [state, setState] = useState(propValue);

  useUpdate(() => {
    if (state === initial) {
      setState(propValue);
    }
  }, [propValue]);

  return [state, setState];
};
